const TRANSITION_DURATION_MS = 150;
const tableCls = "_275t1pmrl9m";
const transitionCls = "_275trfmify";

export { TRANSITION_DURATION_MS, tableCls, transitionCls };
import "./styles.linaria.module.css";
//# sourceMappingURL=styles.js.map
